<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Prescriptions</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="caption">
          <h3 class="page-title" style="float: left;margin-top: 5px;">Prescriptions records list</h3>
          <button
            :disabled="processed"
            style="float:left; margin-left:10px;"
            class="btn btn-primary"
            @click="updateList"
          >
            <i class="icon-fa icon-fa-refresh" />Refresh
          </button>
        </div>
        <div class="actions">
          <router-link v-if="$store.state.permissions.create.prescriptions" :to="{ name: 'prescriptions-create' }" style="margin-top: 8px;" class="btn btn-success"><i class="icon-fa icon-fa-edit" /> Create new prescription</router-link>
        </div>
      </div>
    </div>
    <div v-if="bulkPrescriptions.length !== 0" class="card">
      <div class="card-body">
        <a :href="'/admin/prescriptions/print?id=' + bulkPrescriptions.join(',')" target="_blank" class="btn btn-primary">Print</a>
        <button type="button" class="btn btn-warning" @click="clearSelection">Clear selection</button>
      </div>
    </div>
    <tabs v-if="$store.state.permissions.see.prescriptions" ref="formTypes" class="tabs-default status-switch">
      <tab id="new-prescriptions" name="New">
        <div class="row">
          <div class="col-xl-12">
            <table-component ref="newPrescriptions" :show-filter="false" :data="fetchNewForms" sort-by="created_at" sort-order="desc" table-class="table" @rowClick="rowClicked">
              <table-column
                :sortable="false"
                :filterable="false"
                label=""
              >
                <template slot-scope="row">
                  <input v-model="bulkPrescriptions" :value="row.id" type="checkbox" @click.stop="() => true" >
                </template>
              </table-column>
              <table-column show="id" label="#"/>
              <table-column show="created_at" label="Date" data-type="date:YY/MM/DD"/>
              <table-column show="prescription_variant" label="Variant"/>
              <table-column show="prescription_type" label="Type"/>
              <table-column show="status" label="Status">
                <template slot-scope="row">
                  <span v-if="row.status == 'new'" class="btn btn-xs btn-primary">New</span>
                  <span v-if="row.status == 'viewed'" class="btn btn-xs btn-info">Viewed</span>
                  <span v-if="row.status == 'canceled'" class="btn btn-xs btn-danger">Canceled</span>
                  <span v-if="row.status == 'completed'" class="btn btn-xs btn-success">Completed</span>
                  <span v-if="row.status == 'pending'" class="btn btn-xs btn-warning">Pending</span>
                </template>
              </table-column>
              <table-column show="customer" label="Customer's name"/>
              <table-column show="total" label="Total">
                <template slot-scope="row">
                  $ {{ row.total }}
                </template>
              </table-column>
              <table-column
                :sortable="false"
                :filterable="false"
                label="Actions"
              >
                <template slot-scope="row">
                  <i
                    v-tooltip.top-center="'Mark as viewed'"
                    v-if="row.status == 'new'"
                    class="icon-fa icon-fa-envelope-open delete--link"
                    @click.stop="markViewed(row.id)"
                  />&nbsp;&nbsp;
                  <router-link
                    v-if="$store.state.permissions.see.prescriptions || $store.state.permissions.edit.prescriptions"
                    :to="{ name: 'prescriptions-view', params: { prescriptionId: row.id } }"
                    @click.stop="() => true"
                  >
                    <i v-tooltip.top-center="'View'" class="icon-im icon-im-eye" />
                  </router-link>
                  <a :href="'/admin/prescriptions/print?id=' + row.id" class="action" target="_blank" @click.stop="() => true">
                    <i v-tooltip.top-center="'Print'" class="icon-im icon-im-printer delete--link"/>
                  </a>
                  <i
                    v-tooltip.top-center="'Delete'"
                    v-if="$store.state.permissions.delete.prescriptions"
                    class="icon-im icon-im-bin delete--link action"
                    @click.stop="deleteRecord(row.id)"
                  />
                </template>
              </table-column>
            </table-component>
          </div>
        </div>
      </tab>
      <tab id="viewed-prescriptions" name="Viewed">
        <div class="row">
          <div class="col-xl-12">
            <table-component ref="viewedPrescriptions" :show-filter="false" :data="fetchViewedForms" sort-by="created_at" sort-order="desc" table-class="table" @rowClick="rowClicked">
              <table-column
                :sortable="false"
                :filterable="false"
                label=""
              >
                <template slot-scope="row">
                  <input v-model="bulkPrescriptions" :value="row.id" type="checkbox" @click.stop="() => true" >
                </template>
              </table-column>
              <table-column show="id" label="#"/>
              <table-column show="created_at" label="Date" data-type="date:YY/MM/DD"/>
              <table-column show="prescription_variant" label="Variant"/>
              <table-column show="prescription_type" label="Type"/>
              <table-column show="status" label="Status">
                <template slot-scope="row">
                  <span v-if="row.status == 'new'" class="btn btn-xs btn-primary">New</span>
                  <span v-if="row.status == 'viewed'" class="btn btn-xs btn-info">Viewed</span>
                  <span v-if="row.status == 'canceled'" class="btn btn-xs btn-danger">Canceled</span>
                  <span v-if="row.status == 'completed'" class="btn btn-xs btn-success">Completed</span>
                  <span v-if="row.status == 'pending'" class="btn btn-xs btn-warning">Pending</span>
                </template>
              </table-column>
              <table-column show="customer" label="Customer's name"/>
              <table-column show="total" label="Total"/>
              <table-column
                :sortable="false"
                :filterable="false"
                label="Actions"
              >
                <template slot-scope="row">
                  <router-link
                    v-if="$store.state.permissions.see.prescriptions || $store.state.permissions.edit.prescriptions"
                    :to="{ name: 'prescriptions-view', params: { prescriptionId: row.id } }"
                    @click.stop="() => true"
                  >
                    <i v-tooltip.top-center="'View'" class="icon-im icon-im-eye" />
                  </router-link>
                  <a :href="'/admin/prescriptions/print?id=' + row.id" class="action" target="_blank" @click.stop="() => true">
                    <i v-tooltip.top-center="'Print'" class="icon-im icon-im-printer delete--link"/>
                  </a>
                  <i
                    v-tooltip.top-center="'Delete'"
                    v-if="$store.state.permissions.delete.prescriptions"
                    class="icon-im icon-im-bin delete--link action"
                    @click.stop="deleteRecord(row.id)"
                  />
                </template>
              </table-column>
            </table-component>
          </div>
        </div>
      </tab>
      <tab id="pending-prescriptions" name="Pending">
        <div class="row">
          <div class="col-xl-12">
            <table-component ref="pendingPrescriptions" :show-filter="false" :data="fetchPendingForms" sort-by="created_at" sort-order="desc" table-class="table" @rowClick="rowClicked">
              <table-column
                :sortable="false"
                :filterable="false"
                label=""
              >
                <template slot-scope="row">
                  <input v-model="bulkPrescriptions" :value="row.id" type="checkbox" @click.stop="() => true" >
                </template>
              </table-column>
              <table-column show="id" label="#"/>
              <table-column show="created_at" label="Date" data-type="date:YY/MM/DD"/>
              <table-column show="prescription_variant" label="Variant"/>
              <table-column show="prescription_type" label="Type"/>
              <table-column show="status" label="Status">
                <template slot-scope="row">
                  <span v-if="row.status == 'new'" class="btn btn-xs btn-primary">New</span>
                  <span v-if="row.status == 'viewed'" class="btn btn-xs btn-info">Viewed</span>
                  <span v-if="row.status == 'canceled'" class="btn btn-xs btn-danger">Canceled</span>
                  <span v-if="row.status == 'completed'" class="btn btn-xs btn-success">Completed</span>
                  <span v-if="row.status == 'pending'" class="btn btn-xs btn-warning">Pending</span>
                </template>
              </table-column>
              <table-column show="customer" label="Customer's name"/>
              <table-column show="total" label="Total"/>
              <table-column
                :sortable="false"
                :filterable="false"
                label="Actions"
              >
                <template slot-scope="row">
                  <router-link
                    v-if="$store.state.permissions.see.prescriptions || $store.state.permissions.edit.prescriptions"
                    :to="{ name: 'prescriptions-view', params: { prescriptionId: row.id } }"
                    @click.stop="() => true"
                  >
                    <i v-tooltip.top-center="'View'" class="icon-im icon-im-eye" />
                  </router-link>
                  <a :href="'/admin/prescriptions/print?id=' + row.id" class="action" target="_blank" @click.stop="() => true">
                    <i v-tooltip.top-center="'Print'" class="icon-im icon-im-printer delete--link"/>
                  </a>
                  <i
                    v-tooltip.top-center="'Delete'"
                    v-if="$store.state.permissions.delete.prescriptions"
                    class="icon-im icon-im-bin delete--link action"
                    @click.stop="deleteRecord(row.id)"
                  />
                </template>
              </table-column>
            </table-component>
          </div>
        </div>
      </tab>
      <tab id="completed-prescriptions" name="Completed">
        <div class="row">
          <div class="col-xl-12">
            <table-component ref="completedPrescriptions" :show-filter="false" :data="fetchCompletedForms" sort-by="created_at" sort-order="desc" table-class="table" @rowClick="rowClicked">
              <table-column
                :sortable="false"
                :filterable="false"
                label=""
              >
                <template slot-scope="row">
                  <input v-model="bulkPrescriptions" :value="row.id" type="checkbox" @click.stop="() => true" >
                </template>
              </table-column>
              <table-column show="id" label="#"/>
              <table-column show="created_at" label="Date" data-type="date:YY/MM/DD"/>
              <table-column show="prescription_variant" label="Variant"/>
              <table-column show="prescription_type" label="Type"/>
              <table-column show="status" label="Status">
                <template slot-scope="row">
                  <span v-if="row.status == 'new'" class="btn btn-xs btn-primary">New</span>
                  <span v-if="row.status == 'viewed'" class="btn btn-xs btn-info">Viewed</span>
                  <span v-if="row.status == 'canceled'" class="btn btn-xs btn-danger">Canceled</span>
                  <span v-if="row.status == 'completed'" class="btn btn-xs btn-success">Completed</span>
                  <span v-if="row.status == 'pending'" class="btn btn-xs btn-warning">Pending</span>
                </template>
              </table-column>
              <table-column show="customer" label="Customer's name"/>
              <table-column show="total" label="Total"/>
              <table-column
                :sortable="false"
                :filterable="false"
                label="Actions"
              >
                <template slot-scope="row">
                  <router-link
                    v-if="$store.state.permissions.see.prescriptions || $store.state.permissions.edit.prescriptions"
                    :to="{ name: 'prescriptions-view', params: { prescriptionId: row.id } }"
                    @click.stop="() => true"
                  >
                    <i v-tooltip.top-center="'View'" class="icon-im icon-im-eye" />
                  </router-link>
                  <a :href="'/admin/prescriptions/print?id=' + row.id" class="action" target="_blank" @click.stop="() => true">
                    <i v-tooltip.top-center="'Print'" class="icon-im icon-im-printer delete--link"/>
                  </a>
                  <i
                    v-tooltip.top-center="'Delete'"
                    v-if="$store.state.permissions.delete.prescriptions"
                    class="icon-im icon-im-bin delete--link action"
                    @click.stop="deleteRecord(row.id)"
                  />
                </template>
              </table-column>
            </table-component>
          </div>
        </div>
      </tab>
      <tab id="canceled-prescriptions" name="Canceled">
        <div class="row">
          <div class="col-xl-12">
            <table-component ref="canceledPrescriptions" :show-filter="false" :data="fetchCanceledForms" sort-by="created_at" sort-order="desc" table-class="table" @rowClick="rowClicked">
              <table-column
                :sortable="false"
                :filterable="false"
                label=""
              >
                <template slot-scope="row">
                  <input v-model="bulkPrescriptions" :value="row.id" type="checkbox" @click.stop="() => true" >
                </template>
              </table-column>
              <table-column show="id" label="#"/>
              <table-column show="created_at" label="Date" data-type="date:YY/MM/DD"/>
              <table-column show="prescription_variant" label="Variant"/>
              <table-column show="prescription_type" label="Type"/>
              <table-column show="status" label="Status">
                <template slot-scope="row">
                  <span v-if="row.status == 'new'" class="btn btn-xs btn-primary">New</span>
                  <span v-if="row.status == 'viewed'" class="btn btn-xs btn-info">Viewed</span>
                  <span v-if="row.status == 'canceled'" class="btn btn-xs btn-danger">Canceled</span>
                  <span v-if="row.status == 'completed'" class="btn btn-xs btn-success">Completed</span>
                  <span v-if="row.status == 'pending'" class="btn btn-xs btn-warning">Pending</span>
                </template>
              </table-column>
              <table-column show="customer" label="Customer's name"/>
              <table-column show="total" label="Total"/>
              <table-column
                :sortable="false"
                :filterable="false"
                label="Actions"
              >
                <template slot-scope="row">
                  <router-link
                    v-if="$store.state.permissions.see.prescriptions || $store.state.permissions.edit.prescriptions"
                    :to="{ name: 'prescriptions-view', params: { prescriptionId: row.id } }"
                    @click.stop="() => true"
                  >
                    <i v-tooltip.top-center="'View'" class="icon-im icon-im-eye" />
                  </router-link>
                  <a :href="'/admin/prescriptions/print?id=' + row.id" class="action" target="_blank" @click.stop="() => true">
                    <i v-tooltip.top-center="'Print'" class="icon-im icon-im-printer delete--link"/>
                  </a>
                  <i
                    v-tooltip.top-center="'Delete'"
                    v-if="$store.state.permissions.delete.prescriptions"
                    class="icon-im icon-im-bin delete--link action"
                    @click.stop="deleteRecord(row.id)"
                  />
                </template>
              </table-column>
            </table-component>
          </div>
        </div>
      </tab>
    </tabs>
    <div v-else class="card">
      <div class="card-body">
        <div>
          <h3>You have not permission for do that</h3>
        </div>
      </div>
    </div>
    <div v-if="bulkPrescriptions.length !== 0" class="card" style="margin-top: 1.5rem;">
      <div class="card-body">
        <a :href="'/admin/prescriptions/print?id=' + bulkPrescriptions.join(',')" target="_blank" class="btn btn-primary">Print</a>
        <button type="button" class="btn btn-warning" @click="clearSelection">Clear selection</button>
      </div>
    </div>
    <sweet-modal ref="delete_confirm" hide-close-button blocking title="Confirm delete">
      Confirm delete prescription record
      <button
        slot="button"
        type="button"
        class="btn btn-primary"
        @click="cancelDelete()"
      >Cancel</button>
      <button slot="button" type="button" class="btn btn-danger" @click="deleteRecord()">Confirm</button>
    </sweet-modal>
  </div>
</template>

<script>
/* global axios, toastr */
import { Tabs, Tab } from 'vue-tabs-component'
import { SweetModal } from 'sweet-modal-vue'

export default {
  name: 'PrescriptionsList',
  components: {
    SweetModal,
    tabs: Tabs,
    tab: Tab
  },
  data () {
    return {
      bulkPrescriptions: [],
      processed: false,
      recordForDelete: null
    }
  },
  timers: {
    updateList: {
      time: 60000,
      autostart: true,
      repeat: true
    }
  },
  methods: {
    deleteRecord (id) {
      let that = this
      if (this.recordForDelete) {
        axios
          .delete('/api/admin/prescriptions/' + this.recordForDelete)
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              that.updateList()
              that.recordForDelete = null
              toastr['success']('Record has been deleted successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
              that.recordForDelete = null
            }
          })
          .catch(error => {
            console.log(error)
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
        this.$refs.delete_confirm.close()
      } else {
        this.recordForDelete = id
        this.$refs.delete_confirm.open()
      }
    },
    markViewed (id) {
      let that = this
      if (id) {
        axios
          .get('/api/admin/prescriptions/status/' + id)
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              that.updateList()
              toastr['success']('Record has been change status successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            console.log(error)
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
      }
    },
    updateList () {
      if (this.$refs.formTypes.activeTabIndex === 0) {
        this.$refs.newPrescriptions.refresh()
      } else if (this.$refs.formTypes.activeTabIndex === 1) {
        this.$refs.pendingPrescriptions.refresh()
      } else if (this.$refs.formTypes.activeTabIndex === 2) {
        this.$refs.completedPrescriptions.refresh()
      } else if (this.$refs.formTypes.activeTabIndex === 3) {
        this.$refs.canceledPrescriptions.refresh()
      } else if (this.$refs.formTypes.activeTabIndex === 4) {
        this.$refs.viewedPrescriptions.refresh()
      }
    },
    clearSelection () {
      this.bulkPrescriptions = []
    },
    rowClicked (row) {
      if (row.data && row.data.id) {
        this.$router.push('/admin/prescriptions/' + row.data.id)
      }
    },
    async fetchNewForms ({ page, filter, sort }) {
      const response = await this.fetchRows(page, filter, sort, 'new')

      return response
    },
    async fetchPendingForms ({ page, filter, sort }) {
      const response = await this.fetchRows(page, filter, sort, 'pending')

      return response
    },
    async fetchCompletedForms ({ page, filter, sort }) {
      const response = await this.fetchRows(page, filter, sort, 'completed')

      return response
    },
    async fetchCanceledForms ({ page, filter, sort }) {
      const response = await this.fetchRows(page, filter, sort, 'canceled')

      return response
    },
    async fetchViewedForms ({ page, filter, sort }) {
      const response = await this.fetchRows(page, filter, sort, 'viewed')

      return response
    },
    async fetchRows (page, filter, sort, status) {
      this.$timer.stop('updateList')

      const response = await axios.post('/api/admin/prescriptions', {
        status: status,
        page: page,
        filter: filter,
        sort: sort
      })

      this.$timer.start('updateList')

      return {
        data: response.data.prescriptions,
        pagination: {
          totalPages: response.data.totalPages,
          currentPage: response.data.currentPage,
          count: response.data.count
        }
      }
    }
  }
}
</script>

<style>
.delete--link:hover {
  cursor: pointer;
}
</style>
